// The document itself: the cards that belong to the whole of it, then the
// text (design §8.1, §14.2).
//
// This is the index route under /d/:id rather than part of the screen, so
// that a panel opening over it is a navigation and not a state — which is
// what makes going back from a panel land here instead of at the library.
// Everything it draws with comes down the outlet from the screen, which
// stays mounted underneath and keeps the document's store, outbox and event
// stream alive the whole time.

import { useLayoutEffect } from "react";

import { EvaluationCard } from "../advisor/EvaluationCard";
import { Editor } from "../editor/Editor";
import { useDocument } from "./documentContext";

export function DocumentBody() {
  const {
    doc,
    store,
    advisor,
    liveSelection,
    onSelectionChange,
    onTextSelection,
    clearText,
    find,
    trays,
    trayCounts,
    docWide,
    openTray,
    onToggleTray,
    renderCard,
    onDismissEvaluation,
    pendingScroll,
  } = useDocument();

  // A panel asked for a paragraph on its way out. It could not scroll to it
  // itself — this was not mounted yet — so it left the id behind.
  useLayoutEffect(() => {
    const id = pendingScroll.current;
    if (id === null) return;
    pendingScroll.current = null;
    document
      .querySelector(`[data-paragraph-id="${id}"]`)
      ?.scrollIntoView({ block: "center", behavior: "smooth" });
  }, [pendingScroll]);

  const evaluation = advisor.state.evaluation;

  return (
    <>
      {/* The cards above the text (design §8.1): where the author stands,
          then anything with no paragraph to sit under. Both at the width of
          the text, and both shut until opened. */}
      {(evaluation || docWide.length > 0) && (
        <div className="doc-top">
          {evaluation && evaluation.state === "live" && (
            <EvaluationCard evaluation={evaluation} onDismiss={onDismissEvaluation} />
          )}
          {docWide.map((c) => renderCard(c))}
        </div>
      )}
      <Editor
        doc={doc}
        store={store}
        selection={liveSelection}
        onSelectionChange={onSelectionChange}
        onTextSelection={onTextSelection}
        clearText={clearText}
        found={find.matches}
        lookingAt={find.current}
        trays={trayCounts}
        openTray={openTray}
        onToggleTray={onToggleTray}
        renderTray={(id) => (trays.get(id) ?? []).map((c) => renderCard(c))}
      />
    </>
  );
}
